import Highway from '@dogstudio/highway'
import gsap from 'gsap'
import { classesInjection } from '../utils/transitions'

const duration = 0.3

class FadeTransition extends Highway.Transition {
  in ({ from, to, done }) {
    classesInjection(to)

    from.remove()
    gsap.fromTo(
      to,
      { opacity: 0 },
      {
        opacity: 1,
        duration,
        onComplete: done
      }
    )
    return this
  }

  out ({ from, done }) {
    gsap.fromTo(
      from,
      { opacity: 1 },
      {
        opacity: 0,
        duration,
        onComplete: done
      }
    )
    return this
  }
}

export default FadeTransition
